import React, { useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';

import AnalyticsHelper from '../../../../helpers/AnalyticsHelper';

import Yacht from '../../../Event/components/ApplyComponents/yacht';
import IsShowModals from '../../../../components/Modals/IsShowModal';

import cls from '../sidebar.module.scss';

const YachtData = loadable(() =>
  import(
    /* webpackPrefetch: true, webpackChunkName: "YachtProfileData" */ '../../../Profile/components/MyYahts/Yacht/component/YachtData'
  ),
);

function SideBarYacht({ yacht, event }) {
  const [isShowModal, setIsShowModal] = useState(false);
  const [content, setContent] = useState({});

  if (yacht.slug === 'isTheoreticCourses') {
    return '';
  }

  const modalBoat = (yachtObj) => {
    AnalyticsHelper.sendStaticEvent('purchaseYachtOpen', {
      slug: event.slug,
      category: event.category,
      yacht: yachtObj.slug,
    });
    return <YachtData boat={yacht} isModal />;
  };

  return (
    <div className={cls.offerBox_captain}>
      {yacht && yacht.slug && (
        <div
          className={cls.captain_container}
          onClick={() => {
            setIsShowModal(true);
            return setContent(modalBoat(yacht));
          }}
          onKeyDown={() => {}}
          role="button"
          tabIndex={0}
        >
          <Yacht myYacht={yacht} isOfferLine />
        </div>
      )}
      {content && (
        <IsShowModals
          deed={isShowModal}
          closeDeed={() => setIsShowModal(false)}
          modalContent={content}
          title=""
        />
      )}
    </div>
  );
}

SideBarYacht.propTypes = {
  yacht: PropTypes.shape(),
  event: PropTypes.shape(),
};
SideBarYacht.defaultProps = {
  yacht: {},
  event: {},
};

export default SideBarYacht;
